import { Card } from "antd";
import { DownloadOutlined, LinkOutlined, LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import type { SidebarContent } from "../../config/modulePageConfig";
import docsFetcher from "../../services/api/DocsFetch";
import styles from "./RightSidebar.module.css";

const DownloadLink = ({ label, filename }: { label: string; filename: string }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      await docsFetcher.download(filename);
    } catch {
      console.error("Error descarregant el document");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button className={styles.sourceLink} type="button" onClick={handleClick}>
      {loading ? <LoadingOutlined /> : <DownloadOutlined />} {label}
    </button>
  );
};

const SidebarCards = ({
  question,
  periodYears,
  dimensions,
  fontSources,
}: SidebarContent) => {
  return (
    <>
      <Card className={styles.card}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>PREGUNTA</h4>
        </div>
        <div className={styles.cardContent}>
          <p>{question}</p>
        </div>
      </Card>

      <Card className={`${styles.card} ${styles.periodCard}`}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>PERÍODE TEMPORAL</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.periodInput}>
            <span>{periodYears}</span>
          </div>
        </div>
      </Card>

      <Card className={`${styles.card} ${styles.dimensionsCard}`}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>DIMENSIONS ANALITZADES</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.tagsContainer}>
            {dimensions.map((label, i) => (
              <span key={i} className={styles.tag}>
                {label}
              </span>
            ))}
          </div>
        </div>
      </Card>

      <Card className={styles.card}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>FONTS</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.sourceLinks}>
            {fontSources.map((source, i) => {
              if (!source.url) {
                return (
                  <span key={i} className={styles.sourceLink}>
                    <LinkOutlined /> {source.label}
                  </span>
                );
              }

              if (source.download) {
                return <DownloadLink key={i} label={source.label} filename={source.url} />;
              }

              return (
                <a
                  key={i}
                  className={styles.sourceLink}
                  href={source.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkOutlined /> {source.label}
                </a>
              );
            })}
          </div>
        </div>
      </Card>
    </>
  );
};

export default SidebarCards;
